// Panel hero del login (columna izquierda, solo desktop `lg:`).
// Gradiente teal de marca + frase dinámica + pie de copyright.
// En móvil queda oculto: el logo se muestra arriba del formulario.
//
// Logo inline (mismo SVG que el navbar del shell, ver
// packages/agiohub-shell/src/chrome/Header.js): self-contained, no depende de
// una imagen externa (la anterior apuntaba a agiotech.com y salía rota).
const LOGO_SVG = `
  <svg viewBox="0 0 58.7 58.7" class="h-7 w-7" fill="none" aria-hidden="true">
    <path fill="#00ACBD" d="M58.7,26.3v6.1C58.7,47,47,58.7,32.4,58.7h-6.1C11.8,58.7,0,47,0,32.4c0-8.3,6.7-15,15-15H19c-2.9,2.5-4.8,6.2-4.8,10.4V31c0,7.5,6.1,13.6,13.6,13.6H31c7.5,0,13.6-6.1,13.6-13.6v-3.2c0-7.5-6.1-13.6-13.6-13.6h-1.6v0H3C7.4,5.7,16.2,0,26.3,0h6.1C47,0,58.7,11.8,58.7,26.3"/>
  </svg>`

export function AuthHero(phrase) {
  const headline = phrase?.headline || 'Bienvenido a Agio Hub.'
  const subtitle = phrase?.subtitle || ''
  const year = new Date().getFullYear()

  return `
    <div class="auth-hero relative hidden lg:flex flex-col justify-between p-12 xl:p-16 text-white overflow-hidden">
      <!-- Marca -->
      <div class="relative z-10 flex items-center gap-3 enter">
        <span class="auth-hero-badge">
          ${LOGO_SVG}
        </span>
        <span class="font-headline font-bold text-xl tracking-tight">Agio Hub</span>
      </div>

      <!-- Frase dinámica -->
      <div class="relative z-10 max-w-xl enter enter-delay-2">
        <h1 class="font-headline font-extrabold text-4xl xl:text-6xl leading-[1.05] tracking-tight">
          ${headline}
        </h1>
        ${
          subtitle
            ? `<p class="mt-6 max-w-md text-white/80 text-lg leading-relaxed">${subtitle}</p>`
            : ''
        }
      </div>

      <!-- Pie -->
      <div class="relative z-10 text-white/70 text-sm enter enter-delay-3">
        Agiotech &copy; Copyright ${year}
      </div>
    </div>
  `
}
